// extracted by mini-css-extract-plugin
module.exports = {"sm":"48em","md":"64em","lg":"75em"};